export const buildSupplierSoftDeleteUpdates = (deletedAt) => ({
  isDeleted: true,
  deletedAt,
});

export const buildSupplierRestoreUpdates = () => ({
  isDeleted: false,
  deletedAt: null,
});
